import type { ExploratoryTestListItem } from './types';

/**
 * True when the Plan sidebar tab has any content to render. Drives the
 * empty-state placeholder — the panel hides "No plan yet" as soon as one
 * of these fields is populated.
 *
 * The checklist (`reportJson.testPlan` / `appended`) deliberately does NOT
 * count here: it renders on the Report tab, not the Plan tab. This gate
 * tracks only what `PlanPanel` shows — summary, the source PR/ticket link,
 * staged-data notes, the untestable delta, and the coverage warning.
 *
 * Call only on a full-detail row (`findById` / the detail endpoint). The list
 * query projects a skinny payload that omits these `planned*` columns, so a
 * list row would always read `false`.
 */
export function hasPlanContent(
  test: Pick<
    ExploratoryTestListItem,
    | 'plannedSummary'
    | 'plannedUntestable'
    | 'plannedDataNotes'
    | 'coverageWarning'
    | 'externalTicketUrl'
  >
): boolean {
  const untestable = Array.isArray(test.plannedUntestable) ? test.plannedUntestable : [];
  return (
    untestable.length > 0 ||
    !!test.plannedSummary ||
    !!test.plannedDataNotes ||
    !!test.coverageWarning ||
    !!test.externalTicketUrl
  );
}
